import React from 'react';

function timeAgo(dt) {
  if (!dt) return null;
  const secs = Math.floor((Date.now() - new Date(dt)) / 1000);
  if (secs < 60)    return 'just now';
  if (secs < 3600)  return `${Math.floor(secs / 60)} minutes ago`;
  if (secs < 86400) return `${Math.floor(secs / 3600)} hours ago`;
  return `${Math.floor(secs / 86400)} days ago`;
}

function threshold(score) {
  if (score == null)  return { color: '#aaa',     label: 'No data' };
  if (score >= 90)    return { color: '#1a7a4a',  label: 'Excellent' };
  if (score >= 70)    return { color: '#27ae60',  label: 'Good' };
  if (score >= 40)    return { color: '#f59e0b',  label: 'Fair' };
  return               { color: '#E96A6A',  label: 'At risk' };
}

/**
 * HealthScoreBadge
 *
 * Compact dot + score + label used on CRM kanban cards and panels.
 *
 * Props:
 *   score    — integer 0–100 or null/undefined
 *   scoredAt — Date or ISO string of last calculation (for tooltip)
 *   style    — optional inline style overrides
 */
export default function HealthScoreBadge({ score, scoredAt, style, ...rest }) {
  const { color, label } = threshold(score ?? null);
  const ago = timeAgo(scoredAt);
  const tooltip = ago ? `Last calculated: ${ago}` : 'Score not yet calculated';

  return (
    <span
      title={tooltip}
      {...rest}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.3rem',
        fontSize: '0.72rem',
        fontWeight: 700,
        color,
        fontFamily: "'Raleway', sans-serif",
        whiteSpace: 'nowrap',
        cursor: 'default',
        ...style,
      }}
    >
      <span style={{
        width: 10, height: 10,
        borderRadius: '50%',
        background: color,
        flexShrink: 0,
        display: 'inline-block',
      }} />
      {score != null && <span>{score}</span>}
      {label}
    </span>
  );
}
